/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractFunnelDto } from './BorrowerContractFunnelDto';
import {
    BorrowerContractFunnelDtoFromJSON,
    BorrowerContractFunnelDtoFromJSONTyped,
    BorrowerContractFunnelDtoToJSON,
    BorrowerContractFunnelDtoToJSONTyped,
} from './BorrowerContractFunnelDto';

/**
 * 
 * @export
 * @interface BorrowerCartItemDto
 */
export interface BorrowerCartItemDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerCartItemDto
     */
    name: string;
    /**
     * 
     * @type {BorrowerContractFunnelDto}
     * @memberof BorrowerCartItemDto
     */
    contractFunnel: BorrowerContractFunnelDto;
    /**
     * Borrower commission code applied to this cart item (e.g. "40/10")
     * @type {string}
     * @memberof BorrowerCartItemDto
     */
    borrowerCommission?: string;
}

/**
 * Check if a given object implements the BorrowerCartItemDto interface.
 */
export function instanceOfBorrowerCartItemDto(value: object): value is BorrowerCartItemDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contractFunnel' in value) || value['contractFunnel'] === undefined) return false;
    return true;
}

export function BorrowerCartItemDtoFromJSON(json: any): BorrowerCartItemDto {
    return BorrowerCartItemDtoFromJSONTyped(json, false);
}

export function BorrowerCartItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerCartItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'contractFunnel': BorrowerContractFunnelDtoFromJSON(json['contractFunnel']),
        'borrowerCommission': json['borrowerCommission'] == null ? undefined : json['borrowerCommission'],
    };
}

export function BorrowerCartItemDtoToJSON(json: any): BorrowerCartItemDto {
    return BorrowerCartItemDtoToJSONTyped(json, false);
}

export function BorrowerCartItemDtoToJSONTyped(value?: BorrowerCartItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'contractFunnel': BorrowerContractFunnelDtoToJSON(value['contractFunnel']),
        'borrowerCommission': value['borrowerCommission'],
    };
}

